import React from "react";
import { useLocation } from "react-router-dom";
import AdminDetailedReport from "./AdminDetailedReport";
import { getGroundingDetailsByVin } from "../service/api";


export default function VehicleHistory(props) {
    const [inspectiondata, setinspectiondata] = React.useState(null);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const vin = queryParams.get("vin");
    const groundingId = queryParams.get("groundingId")
    React.useEffect(() => {
        getGroundingDetail();
    }, []);


    async function getGroundingDetail() {        
        let apiResponse = await getGroundingDetailsByVin(vin, groundingId);
        console.log(apiResponse);
        
        if (apiResponse && apiResponse?.data) {            
            setinspectiondata(apiResponse?.data);
        }
    }

    return (
        <div style={{ marginLeft: "50px", marginRight: "50px", marginBottom: "50px" }}>
            {inspectiondata && 
            <AdminDetailedReport
                inspectiondata={inspectiondata}
                vin={vin}
                groundingId = {groundingId}
            />}
        </div>
    );
}